import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WebsiteShell } from "./website-shell.js";
import { LandingPage } from "./pages/landing-page.js";
import { MarketplacePage } from "./pages/marketplace-page.js";
import { MarketplaceCategoryPage } from "./pages/marketplace-category-page.js";
import { GuideDetailPage } from "./pages/guide-detail-page.js";
import { CompanyPage } from "./pages/company-page.js";
import "./styles/website-theme.css";

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <BrowserRouter>
      <Routes>
        <Route element={<WebsiteShell />}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/marketplace" element={<MarketplacePage />} />
          <Route path="/marketplace/category/:slug" element={<MarketplaceCategoryPage />} />
          <Route path="/marketplace/:slug" element={<GuideDetailPage />} />
          <Route path="/company" element={<CompanyPage />} />
        </Route>
      </Routes>
    </BrowserRouter>,
  );
}
